/**
 * Labstep
 *
 * @module prosemirror/components/Menu/Action/ProtocolValue
 * @desc Convert selected text into an ProtocolValue node
 */

import { ICONS } from 'labstep-web/constants/icons';
import { EntityCreateContainer } from 'labstep-web/containers/Entity/Create';
import { Button } from 'labstep-web/core/Button';
import { Icon } from 'labstep-web/core/Icon';
import type {
  APICreateAction,
  APIResponse,
} from 'labstep-web/models';
import { ProtocolValue } from 'labstep-web/models/protocol-value.model';
import { NodeValue as NodeProtocolValue } from 'labstep-web/prosemirror/nodes/protocol-value';
import { getSelectedText } from 'labstep-web/prosemirror/utils';
import type { EditorView } from 'prosemirror-view';
import type React from 'react';
import type { IMenuTextActionProtocolValueProps } from './types';

export const createProtocolValueNode = (
  view: EditorView,
  response: APIResponse,
): void => {
  const { tr } = view.state;
  const { key } = NodeProtocolValue;
  const node = view.state.schema.nodes[key].create({
    id: response.entities[key][response.result as any].id,
    guid: response.entities[key][response.result as any].guid,
  });
  tr.setStoredMarks([]);
  tr.replaceSelectionWith(node);
  view.dispatch(tr);
  view.focus();
};

export const createProtocolValue = (
  view: EditorView,
  create: APICreateAction<'protocol_value'>,
): void => {
  const selectedText = getSelectedText(view.state);
  if (selectedText && selectedText.length > 0) {
    create(
      {
        name: selectedText,
      },
      {
        additionalMeta: { redirect: true },
        onSuccess: ({ response }) =>
          createProtocolValueNode(view, response),
      },
    );
  }
};

export const MenuTextActionProtocolValue: React.FC<
  IMenuTextActionProtocolValueProps
> = ({ view, protocol }) => (
  <EntityCreateContainer
    entityName={ProtocolValue.entityName}
    parentName={protocol.entityName}
    parentId={protocol.id}
  >
    {({ create, status }): React.ReactElement => (
      <Button
        onClick={(): void => createProtocolValue(view, create)}
        status={status}
      >
        <Icon name={ICONS.resource.primary} />
        <span>Inventory</span>
      </Button>
    )}
  </EntityCreateContainer>
);
